import { Tabs } from '@seiue/ui'
import React, { FC } from 'react'

import { Notification, ReflectionRoleEnum } from 'packages/sdks-next/growp'

import { NoticeDetail } from '@/components/NoticeDetail'

import { RangeTable } from './RangeTable'

/**
 * 资讯详情
 *
 * @param param0 - 参数
 * @param param0.notification - 通知
 * @returns 组件
 */
export const HotNewsDetails: FC<{
  notification: Notification
}> = ({ notification }) => {
  const items = [
    {
      key: 'range',
      label: '发送范围',
      children: <RangeTable notification={notification} />,
    },
    {
      key: 'content',
      label: '资讯内容',
      children: <NoticeDetail notification={notification} />,
    },
  ]

  return (
    <Tabs
      items={items}
      size="small"
    />
  )
}
